module.exports = __webpack_public_path__ + "static/cyclops-505bd6fc754a4d2e63b7244b4f49a00a.jpeg";